import UserEntitlementService from 'src/modules/userEntitlement/userEntitlementService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'USERENTITLEMENT_VIEW';

const userEntitlementViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: userEntitlementViewActions.FIND_STARTED,
      });

      const record = await UserEntitlementService.find(id);

      dispatch({
        type: userEntitlementViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: userEntitlementViewActions.FIND_ERROR,
      });

      getHistory().push('/user-entitlement');
    }
  },
};

export default userEntitlementViewActions;
